<template>
  <div class="index" id="anchor">
    <Seacher></Seacher>
    <!-- translist start -->
    <div class="translist">
      <div class="indexList">
        <div class="tabbox" id="tags">
          <ul id="box">
            <li>
              <Left @menuHandleClick="dianji"></Left>
            </li>
          </ul>
        </div>
      </div>
      <!-- <div class="chartsall"></div> -->
    </div>
    <div class="chartsall">
      <div class="chartsallli" v-show="ind == 0">
        <div class="headtit">Blockchain Data</div>
        <div class="contentchart" id="charts">
          <Charts @click.native.capture.stop="pushs('1-1')"
            >User Transactions</Charts
          >
          <Transactions></Transactions>
        </div>
        <div class="contentchart" id="charts1">
          <Charts @click.native.capture.stop="pushs('1-2')">PeakTPS</Charts>
          <Peak></Peak>
        </div>
        <div class="contentchart" id="charts2">
          <Charts @click.native.capture.stop="pushs('1-3')"
            >Transaction signature total</Charts
          >
          <Signature></Signature>
        </div>
        <div class="contentchart" id="charts3">
          <Charts @click.native.capture.stop="pushs('1-4')"
            >Average Gas Price</Charts
          >

          <Average></Average>
        </div>
        <div class="contentchart" id="charts4">
          <Charts @click.native.capture.stop="pushs('1-5')"
            >Daily Gas Used</Charts
          >

          <Daily></Daily>
        </div>
      </div>
      <div class="chartsallli" v-show="ind == 1">
        <div class="headtit">TTOS circulation</div>
        <div class="contentchart" id="chartsa">
          <Charts @click.native.capture.stop="pushs('2-1')">User Bonus & Burned</Charts>
          <Userbonus></Userbonus>
        </div>
        <div class="contentchart" id="chartsa1">
          <Charts @click.native.capture.stop="pushs('2-2')">TTOS Transaction Volume</Charts>

          <Volume></Volume>
        </div>
        <div class="contentchart" id="chartsa2">
          <Charts @click.native.capture.stop="pushs('2-3')">TTOS Supply & Staking</Charts>
          <Staking></Staking>
        </div>
      </div>
      <div class="chartsallli" v-show="ind == 2">
        <div class="headtit">Accounts</div>
        <div class="contentchart" id="chartsb">
          <Charts @click.native.capture.stop="pushs('3-1')">Total Account & Active Account</Charts>

          <Accounts></Accounts>
        </div>
        <div class="contentchart" id="chartsb1">
          <Charts @click.native.capture.stop="pushs('3-2')">New Accounts Created</Charts>

          <Created></Created>
        </div>
      </div>
      <div class="chartsallli" v-show="ind == 3">
        <div class="headtit">Contracts</div>
        <div class="contentchart" id="chartsc">
          <Charts @click.native.capture.stop="pushs('3-1')">Daily contract call</Charts>
          <Call></Call>
        </div>
        <div class="contentchart" id="chartsc1">
          <Charts @click.native.capture.stop="pushs('3-2')">Daily Contract Call Distribution</Charts>
          <Distribution></Distribution>
        </div>
        <div class="contentchart" id="chartsc2">
          <Charts @click.native.capture.stop="pushs('3-3')">Contract Count</Charts>
          <Count></Count>
        </div>
      </div>
    </div>
    <!-- translist end -->
  </div>
</template>

<script>
import Seacher from "@/components/m/Seacher.vue";
import Transactions from "@/components/m/charts/Blockchain/Transactions.vue";
import Peak from "@/components/m/charts/Blockchain/Peak.vue";
import Signature from "@/components/m/charts/Blockchain/Signature.vue";
import Average from "@/components/m/charts/Blockchain/Average.vue";
import Daily from "@/components/m/charts/Blockchain/Daily.vue";
// 第二部分开始
import Userbonus from "@/components/m/charts/Circulation/Userbonus.vue";
import Volume from "@/components/m/charts/Circulation/Volume.vue";
import Staking from "@/components/m/charts/Circulation/Staking.vue";
// 第三部分开始
import Accounts from "@/components/m/charts/Accounts/Accounts.vue";
import Created from "@/components/m/charts/Accounts/Created.vue";
// 第四部分开始
import Call from "@/components/m/charts/Contracts/Call.vue";
import Count from "@/components/m/charts/Contracts/Count.vue";
import Distribution from "@/components/m/charts/Contracts/Distribution.vue";
//公共的组件内容
import Charts from "@/components/m/charts/charts.vue";
import Left from "@/components/m/charts/left.vue";

import { GetChartData } from "@/assets/server/api";
import { timestampConvertTime1 } from "@/utils/utils.js";

const echarts = require("echarts");

export default {
  components: {
    Seacher,
    Transactions,
    Peak,
    Signature,
    Average,
    Daily,
    Userbonus,
    Staking,
    Volume,
    Accounts,
    Created,
    Call,
    Count,
    Distribution,
    Charts,
    Left,
  },
  data() {
    return {
      ImgUrl: require("@/assets/m/xialax.png"),
      // num: 1,
      show: false,
      ind: 0,
      names: "",
      
    };
  },
  computed: {
    getClientTimezone() {
      var oDate = new Date();
      var nTimezone = -oDate.getTimezoneOffset() / 60;
      return nTimezone.toFixed(2);
    },
  },
  created() {},
  mounted() {},
  destroyed() {},
  methods: {
    jump(id, nums) {
      if (nums == false) {
        this.num = "";
      }
      this.num = nums;
     // console.log(this.num);
      this.show = false;
    },
    pushs(nums) {
      this.show = false;
      //this.$router.push("/m/chartsdetail");
      this.$router.push({
        path: "/m/chartsdetail",
        query: { id: nums },
      });
    },
    async getchartsdata() {
      this.limit = 7;
      if (this.itemindex == 0) {
        this.limit = 7;
      } else if (this.itemindex == 1) {
        this.limit = 30;
      }

      let formData = new FormData();
      let params = {
        limit: this.limit,
      };
      let item = params;
      for (const key in item) {
        if (Object.hasOwnProperty.call(item, key)) {
          formData.append(key, item[key]);
        }
      }
      var res = await GetChartData(formData);
      var result = res.result.reverse();
      var time;
      for (var i = 0; i < result.length; i++) {
        let UTCTime =
          res.result[i].createTime - this.getClientTimezone * 3600000;
        time = timestampConvertTime1(UTCTime);
        this.dataday.push(time);
        this.data1.push(result[i].tradeNums);
        this.data2.push(result[i].tradeAmount);
        this.data3.push(result[i].maxTPS);
        this.data4.push(result[i].signCount);
        this.data5.push(result[i].addressCount);
        this.data6.push(result[i].activeAddressCount);
        this.data7.push(parseFloat(result[i].avgGas).toFixed(8));
        this.data8.push(parseFloat(result[i].gasAmount).toFixed(8));
      }
    },
    dianji(payload) {
    //  console.log(payload);
      this.ind = payload.id;
      this.names = payload;
      if (payload == "User Transactions") {
        this.$router.push({
          path: "/m/chartsdetail",
          query: { id: "1-1" },
        });
      }else if(payload == "Peak TPS"){
        this.$router.push({
          path: "/m/chartsdetail",
          query: { id: "1-2" },
        });
      }else if(payload == "Transaction signature total"){
        this.$router.push({
          path: "/m/chartsdetail",
          query: { id: "1-3" },
        });
      }else if(payload == "Average Gas Unit Price"){
        this.$router.push({
          path: "/m/chartsdetail",
          query: { id: "1-4" },
        });
      }else if(payload == "Daily Gas Used"){
        this.$router.push({
          path: "/m/chartsdetail",
          query: { id: "1-5" },
        });
      }else if(payload == "User Bonus & Burned"){
        this.$router.push({
          path: "/m/chartsdetail",
          query: { id: "2-1" },
        });
      }else if(payload == "TTOS Transaction Volume"){
        this.$router.push({
          path: "/m/chartsdetail",
          query: { id: "2-2" },
        });
      }else if(payload == "TTOS Supply & Staking"){
        this.$router.push({
          path: "/m/chartsdetail",
          query: { id: "2-3" },
        });
      }else if(payload == "Total Account & Active Account"){
        this.$router.push({
          path: "/m/chartsdetail",
          query: { id: "3-1" },
        });
      }else if(payload == "New Accounts Created"){
        this.$router.push({
          path: "/m/chartsdetail",
          query: { id: "3-2" },
        });
      }else if(payload == "Daily contract call"){
        this.$router.push({
          path: "/m/chartsdetail",
          query: { id: "4-1" },
        });
      }else if(payload == "Daily Contract Call Distribution"){
        this.$router.push({
          path: "/m/chartsdetail",
          query: { id: "4-2" },
        });
      }
      else if(payload == "Contract Count"){
        this.$router.push({
          path: "/m/chartsdetail",
          query: { id: "4-3" },
        });
      }
    },
  },
  watch: {
    $route: {
      handler: function (to) {
        // console.log(to);
        // console.log(this.$route.query);
        // this.ind = this.$route.query.id;
        var b = JSON.stringify(this.$route.query) == "{}";
      //  console.log(b);
        if(b==true){
          this.ind=0;
        }else if(b==false){
          this.ind = this.$route.query.id;
        }
       // console.log(to.path);
        // if(to.path=="/m/charts"){
        //   this.ind=0;
        // }
       
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style lang="less" scoped>
.index {
  width: 750px;
  margin: 110px auto 0px auto;
  background: #13161b;
  text-align: center;
  .translist {
    height: 100%;
    position: relative;
    width: 750px;
    background: #13161b;

    margin: 0px;
    padding: 0px;
    // min-height: 600px;
    .indexList {
      position: absolute;
      top: 0px;
      // opacity: 0.5;
      // bottom: 200px;
      background: #13161b;
      z-index: 9999;
      //   position: absolute;
      .tabbox {
        display: flex;
        margin-top: 24px;
        margin-left: 24px;

        overflow: hidden;
        ul::-webkit-scrollbar {
          display: none;
        }
        ul {
          overflow-x: auto;
          overflow-y: hidden;
          display: flex;

          li {
            z-index: 9999;
            margin-right: 24px;
            opacity: 1;
            // border: 4px solid;
            border-radius: 24px 24px 24px 24px;
            // width: 260px;
            p {
              white-space: nowrap;
              font-size: 26px;
              font-family: PingFang SC-Medium, PingFang SC;
              font-weight: 500;
              color: #898b8d;
              height: 80px;
              line-height: 80px;
              background: #000000;
              padding-left: 24px;
              padding-right: 24px;
              border: 4px solid;
              border-radius: 24px 24px 24px 24px;
            }
            // .chartbox1{
            //   height: 402px !important;
            // }
            .chartbox {
              margin-top: 14px;

              // width: 356px;
              background: #000000;
              border-radius: 16px 16px 16px 16px;
              opacity: 1;
              border: 3px solid #323f3b;
              .chartli {
                width: 356px;
                padding-left: 24px;
                padding-right: 24px;
                height: 68px;
                font-size: 24px;
                font-family: PingFang SC-Medium, PingFang SC;
                font-weight: 500;
                color: #fdfffe;
                line-height: 68px;
              }
            }
          }
          .active {
            // padding-left: 24px;
            //   padding-right: 24px;
            // width: 254px;
            white-space: nowrap;
            height: 80px;
            background: linear-gradient(124deg, #324c43 0%, #0d402f 100%);
            border-radius: 16px 16px 16px 16px;
            opacity: 1;
            //position: absolute;
            // transform: translateX(-30%);
            // left: 0;
            font-size: 26px;
            font-family: PingFang SC-Medium, PingFang SC;
            font-weight: 500;
            color: #00ffaa;
            line-height: 80px;
            text-align: center;
          }
        }
      }
    }
  }
  .chartsall {
    background: #13161b;
    padding-top: 200px;
    border: 2px solid #13161b;
    left: 24px;
    .chartsallli {
      width: 702px;
      z-index: 9;

      margin: 0 auto;
      // height: 2435px;
      background: #000000;
      border-radius: 24px 24px 24px 24px;
      padding-bottom: 6px;
      margin-bottom: 24px;
      .headtit {
        height: 42px;
        font-size: 30px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #ffffff;
        line-height: 42px;
        padding-top: 24px;
        margin-left: 24px;
        margin-bottom: 48px;
        text-align: left;
      }
      .contentchart {
        width: 654px;
        height: 445px;
        background: #13161b;
        border-radius: 16px 16px 16px 16px;
        opacity: 1;
        margin: 0 auto 24px auto;

        // .contenttit {
        //   display: flex;
        //   justify-content: space-between;
        //   padding-top: 24px;
        //   .contenttitl {
        //     height: 42px;
        //     font-size: 30px;
        //     font-family: PingFang SC-Medium, PingFang SC;
        //     font-weight: 500;
        //     color: #898b8d;
        //     line-height: 42px;
        //     margin-left: 24px;
        //   }
        //   .contenttitr {
        //     width: 147px;
        //     height: 44px;
        //     line-height: 44px;
        //     background: #000000;
        //     border-radius: 8px 8px 8px 8px;
        //     opacity: 1;
        //     font-size: 24px;
        //     font-family: PingFang SC-Medium, PingFang SC;
        //     font-weight: 500;
        //     color: #ffffff;
        //     margin-right: 24px;
        //     span {
        //       margin-left: 24px;
        //       margin-top: 8px;
        //     }
        //     img {
        //       width: 40px;
        //       height: 40px;
        //       margin-left: 6px;
        //       margin-top: 2px;
        //     }
        //   }
        // }
      }
    }
  }
}
</style>
